var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 22.5,
    fill: "#4FCF7E",
    stroke: "#92D4EC",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2874 34.5698C19.3473 34.542 18.5142 34.2185 17.8407 33.5478C15.5644 31.2821 13.2891 29.0153 11.0298 26.7324C9.66466 25.3526 9.66252 23.2133 10.9891 21.8656C12.3265 20.5083 14.4915 20.5094 15.892 21.8892C17.2015 23.179 18.5078 24.4731 19.783 25.7951C20.1546 26.1807 20.3559 26.2278 20.7649 25.8143C24.3165 22.2245 27.8906 18.6572 31.4658 15.0909C33.347 13.2151 36.3622 13.8482 37.2124 16.3014C37.6674 17.6159 37.4051 18.8393 36.4372 19.8152C31.863 24.427 27.2653 29.0142 22.6654 33.6003C22.0219 34.241 21.206 34.5366 20.2874 34.5688V34.5698Z",
    fill: "#FDFEFD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.9ca5ee053cfd6e618d8d3234495a8885.svg";
export { ForwardRef as ReactComponent };